<template>
  <header class="full box">
    <div class="logo">
      <img :src="logo" class="logo-img" alt="BGS Logo">
    </div>

    <div class="nav">

    </div>
  </header>
</template>

<script>
// import SocialMedia from '@/components/SocialMedia.vue';

import Logo from '@/assets/images/logo.png';

export default {
  name: 'TheHeader',
  components: {
    // SocialMedia
  },
  data() {
    return {
      logo: Logo,
    };
  },
};
</script>

<style lang="scss" scoped>
header {
  .logo {
    width:30%;

    .logo-img {
      width:40px;
      height: 40px;
    }
  }
}
</style>
